import { Option } from "@/components/select/AsyncAutocompleteSelect";
import { GetTransferRequestsProps } from "@/services/transfer-requests.service";
import dayjs, { Dayjs } from "dayjs";
import { formatCurrencyInputToNumber } from "@/utils/query-string";

export interface TRFRProps {
  request_date?: Dayjs;
  sucursal: number[];
  request_amount: string;
  requester: string;
  request_type: string[];
  origin_account: Option;
  destiny_account: Option;
  estados?: number[];
}

export const getTransferRequestFilter = (
  event: TRFRProps,
): Partial<GetTransferRequestsProps> => {
  let amount: number | undefined;

  if (event?.request_amount) {
    const num = formatCurrencyInputToNumber(event.request_amount);

    if (!Number.isNaN(num)) {
      amount = Number(num.toFixed(2));
    }
  }

  return {
    ...(event?.request_date && dayjs(event?.request_date).isValid()
      ? {
          Fecha: dayjs(event?.request_date).toISOString(),
        }
      : {}),
    ...(event?.estados?.length
      ? {
          estados: event?.estados,
        }
      : {}),
  
    ...(event?.origin_account
      ? {
          nroCuenta: String(event?.origin_account?.value),
        }
      : {}),
    ...(event?.destiny_account
      ? {
          cuentaDestino: String(event?.destiny_account?.value),
        }
      : {}),
    ...(event?.request_amount && amount
      ? {
          monto: Number(amount),
        }
      : {}),
    ...(event?.requester
      ? {
          solicitante: event?.requester,
        }
      : {}),
  };
};
